import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles, AlertCircle } from 'lucide-react';

export default function Welcome() {
  const navigate = useNavigate();
  const [budget, setBudget] = useState('');
  const [error, setError] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const budgetNumber = parseInt(budget, 10);
    if (budgetNumber < 200) {
      setError('Le dépôt minimum chez RaiseFX est de 200€');
      return;
    }
    const userEmail = localStorage.getItem('userEmail');
    if (!userEmail) {
      setError("Email introuvable. Veuillez vous réinscrire.");
      return;
    }
    setIsUpdating(true);
    try {
      const response = await fetch('/api/user/updateCapital', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ boardId: 7669473566, email: userEmail, capital: budget }),
      });
      if (response.ok) {
        navigate('/trading-account');
      } else {
        const errText = await response.text();
        setError(`Erreur lors de la mise à jour du capital : ${errText}`);
      }
    } catch (err) {
      console.error(err);
      setError('Erreur lors de la mise à jour du capital.');
    } finally {
      setIsUpdating(false);
    }
  };

  const handleBudgetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setBudget(value);
    setError('');
  };

  return (
    <div className="min-h-screen bg-white pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-50 border border-purple-100 mb-8">
            <Sparkles className="w-5 h-5 text-purple-600" />
            <span className="text-purple-700 font-medium">Bienvenue dans la communauté</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Bienvenue chez
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-purple-800 mt-2">
              EvolTrade
            </span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-2">
            Complétez votre profil de trader en quelques secondes
          </p>
        </div>

        {/* Formulaire de budget */}
        <div className="relative">
          <div className="relative bg-white rounded-2xl p-8 md:p-12 border border-gray-200 shadow-xl">
            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Champ budget et gestion d'erreur identiques */}
            </form>
          </div>
        </div>

        {/* Indicateur de progression — Étape 2 sur 2 */}
        <div className="mt-12 flex flex-col items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-purple-200"></div>
            <div className="w-12 h-0.5 bg-purple-200"></div>
            <div className="w-3 h-3 rounded-full bg-purple-600"></div>
          </div>
          <p className="text-gray-500 text-sm">Étape 2 sur 2</p>
        </div>
      </div>
    </div>
  );
}
